import React from 'react'
import { useTranslation } from 'react-i18next'

import ControlledModal from 'components/Modal/ControlledModal'
import UserPhoneVerification from 'components/User/UserPhoneVerification/UserPhoneVerification'
import { MODAL_SIZE } from 'components/Modal/GenericModal/GenericModal'

const UserPhoneVerificationModal = () => {
    const { t } = useTranslation('editProfile')

    return (
        <ControlledModal
            routedModal
            name="user-phone-verification-modal"
            context="userPhoneVerificationModal"
            initialTitle={t('editProfile:verifyPhoneNumber.title')}
            requireUserInput={false}
            size={MODAL_SIZE.SMALL}
        >
            {(modalProps) => (
                <UserPhoneVerification
                    onSubmitted={modalProps.closeModal}
                    onCancel={modalProps.closeModal}
                />
            )}
        </ControlledModal>
    )
}

export default UserPhoneVerificationModal
